import { Fragment, useCallback, useState } from 'react';
import Input from '../../../form/Input';
import { PRef } from '../ProductCreate';

/**
 * @author taulmax
 * @createDate 2024.10.11
 * @updateDate 2024.10.22
 * @description 상품 등록 페이지 - 서비스 형태
 */
const PService = ({ pRef }: PRef<HTMLSelectElement>) => {
  const [pService, setPService] = useState<string>('');
  const onChangePService = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const value = e.target.value;
      if (value === '1' || value === '2' || value === '') {
        setPService(value); // 값이 1, 2이거나 빈 값일 때만 상태를 업데이트
      }
    },
    []
  );

  return (
    <select
      ref={pRef}
      value={pService}
      onChange={onChangePService}
      className="!w-full !h-[42px] !px-3 !border !border-gray-300 !rounded-lg !text-sm !bg-white !cursor-pointer !transition-colors !duration-200 focus:!outline-none focus:!border-blue-400"
    >
      <option value="">서비스 형태를 선택하세요</option>
      <option value="1">1인 서비스</option>
      <option value="2">2인 서비스</option>
    </select>
  );
};

export default PService;
